import React, { Component } from 'react'
import _ from 'lodash'

import Repository from '../../felles/repository'
import Lodading from '../../felles/loading'
import Arbeidsliste from './arbeidsliste'
import { resolve } from '../../dependencies'
import { Maalerstatus } from '../../felles/utils/statuskoder'
import { AppInsights } from 'applicationinsights-js'

export default class ArbeidslisteContainer extends Component {
    constructor() {
        super()

        this.state = {
            vannmaalere: [],
            nyeMaalere: [],
            vannmaalerIder: [],
            tittel: '',
            beskrivelse: '',
            id: 0,
            status: 0,
            isLeggtilVannmaalerModalOpen: false,
            laster: false,
            lasterSms: false,
            feil: null,
            sisteAvtaltDato: null,
            brukere: [],
            lasterSideTekst: 'Henter arbeidsliste'
        }

        this._hentArbeidsliste = this._hentArbeidsliste.bind(this)
        this._onDataMotatt = this._onDataMotatt.bind(this)
        this._oppdaterArbeidsListe = this._oppdaterArbeidsListe.bind(this)
        this._fjernMaalerFraListe = this._fjernMaalerFraListe.bind(this)
        this._sendVarselForArbeidsliste = this._sendVarselForArbeidsliste.bind(this)
        this._settAvtaltForVannmaaler = this._settAvtaltForVannmaaler.bind(this)
        this._leggtilInfoFraKunde = this._leggtilInfoFraKunde.bind(this)
        this._endreAvtaltTidspunt = this._endreAvtaltTidspunt.bind(this)
        this._endreListeIdPaaMaaler = this._endreListeIdPaaMaaler.bind(this)
        this._visOppdatererArbeidsliste = this._visOppdatererArbeidsliste.bind(this)
        this._hentOgOppdaterSmsData = this._hentOgOppdaterSmsData.bind(this)
        this._oppdaterSmsData = this._oppdaterSmsData.bind(this)
    }

    componentDidMount() {
        this.setState({ laster: true })
        this._hentArbeidsliste()
            .then(this._onDataMotatt)
            .catch(() => this.setState({ laster: false, feil: 'Kunne ikke laste arbeidsliste. Prøv å laste siden på nytt.' }))
    }

    _hentArbeidsliste() {
        return resolve(Repository).hentArbeidslisteMedId(this.props.match.params.ListeId)
    }

    _onDataMotatt(arbliste) {
        this.setState({
            vannmaalere: arbliste.VannmaalerePlanlegging,
            vannmaalerIder: _.map(arbliste.VannmaalerePlanlegging, _.property('MaalerId')),
            tittel: arbliste.Tittel,
            beskrivelse: arbliste.Beskrivelse,
            id: arbliste.Id,
            startdato: arbliste.Startdato,
            status: arbliste.Status,
            startTidspunkt: arbliste.StartTidspunkt,
            sluttTidspunkt: arbliste.SluttTidspunkt,
            brukere: arbliste.Brukere,
            laster: false,
            lasterSms: true,
            sisteAvtaltdato:
                !arbliste.VannmaalerePlanlegging || arbliste.VannmaalerePlanlegging.length === 0
                    ? ''
                    : _.last(arbliste.VannmaalerePlanlegging).Avtaltdato
        }, () => {
            this._hentOgOppdaterSmsData(arbliste.Id)
        })
    }

    _hentOgOppdaterSmsData(listeId) {
        resolve(Repository)
            .hentSmsForArbeidsliste(listeId)
            .then(this._oppdaterSmsData)
            .catch(() => this.setState({ lasterSms: false }))
    }

    _oppdaterSmsData(smsData) {
        if (!smsData || !smsData.length) {
            this.setState({ lasterSms: false })
            return
        }
        const oppdaterteVannmaalere = this.state.vannmaalere.map(maaler => {
            const sms = smsData.find(s => s.MaalerId === maaler.MaalerId)
            if (!sms) return maaler
            return Object.assign({}, maaler, {
                SmsStatus: sms.SmsStatus,
                SmsLevertStatus: sms.SmsLevertStatus,
                Mobil: sms.Mobil || maaler.Mobil,
                Status: sms.Status
            })
        })
        this.setState({ vannmaalere: oppdaterteVannmaalere, lasterSms: false })
    }

    _oppdaterArbeidsListe(arbeidsListe) {
        this._visOppdatererArbeidsliste()
        arbeidsListe.ValgteBrukerIder = _.map(this.state.brukere, 'BrukerGUID')

        resolve(Repository)
            .oppdateArbeidsliste(arbeidsListe)
            .then(this._hentArbeidsliste)
            .then(liste => this._onDataMotatt(liste))
    }

    _fjernMaalerFraListe(maalerId) {
        this._visOppdatererArbeidsliste();
        resolve(Repository)
            .fjernMaalerFraArbeidsliste(maalerId)
            .then(this._hentArbeidsliste)
            .then(liste => this._onDataMotatt(liste))
    }

    _sendVarselForArbeidsliste(varsel) {
        AppInsights.trackTrace('Starter varsling for arbeidsliste: ' + this.state.id);
        resolve(Repository)
            .sendVarselForArbeidsliste(varsel)
            .then( (response)  => {
                AppInsights.trackTrace('Send varsel for arbeidsliste ferdig', {response: response});
                console.log(response)
            })
            .then(this._hentArbeidsliste.then(liste => this._onDataMotatt(liste)))
    }

    _settAvtaltForVannmaaler(maalerFraGrid) {
        this._visOppdatererArbeidsliste()

        let maaler = {
            VmId: maalerFraGrid.MaalerId,
            Status: Maalerstatus.Avtalt,
            Avtaltdato: maalerFraGrid.Avtaltdato,
            Kommentar: maalerFraGrid.Kommentar,
            ListeId: this.props.match.params.ListeId
        }

        resolve(Repository)
            .oppdateVannmaalerPaaAbeidsliste(maaler)
            .then(this._hentArbeidsliste)
            .then(liste => this._onDataMotatt(liste))
    }

    _leggtilInfoFraKunde(info, maalerId) {
        this._visOppdatererArbeidsliste()

        let maaler = _.find(this.state.vannmaalere, maaler => maaler.MaalerId === maalerId)

        let maalerSomSkalOppdateres = {
            VmId: maaler.MaalerId,
            Status: maaler.Status,
            Avtaltdato: maaler.Avtaltdato,
            Kommentar: info,
            ListeId: this.props.match.params.ListeId
        }

        resolve(Repository)
            .oppdateVannmaalerPaaAbeidsliste(maalerSomSkalOppdateres)
            .then(this._hentArbeidsliste)
            .then(liste => this._onDataMotatt(liste))
    }

    _endreAvtaltTidspunt(nyTid, maalerId, oppdatereTidspunkt) {
        this._visOppdatererArbeidsliste()

        let maaler = _.find(this.state.vannmaalere, maaler => maaler.MaalerId === maalerId)

        let maalerSomSkalOppdateres = {
            VmId: maaler.MaalerId,
            Status: maaler.Status,
            Avtaltdato: nyTid,
            Kommentar: maaler.Kommentar,
            ListeId: this.props.match.params.ListeId
        }
 
        resolve(Repository)
            .oppdateVannmaalerPaaAbeidsliste(maalerSomSkalOppdateres, oppdatereTidspunkt)
            .then(this._hentArbeidsliste)
            .then(liste => this._onDataMotatt(liste))
    }

    _endreListeIdPaaMaaler(nyListeId, maalerId){
        console.log(nyListeId)
        this._visOppdatererArbeidsliste()

        let maaler = _.find(this.state.vannmaalere, maaler => maaler.MaalerId === maalerId)
        let maalerSomSkalOppdateres = {
            VmId: maaler.MaalerId,
            ListeId: this.props.match.params.ListeId,
            NyListeId: nyListeId
        }
        resolve(Repository)
        .oppdateVannmaalerPaaAbeidsliste(maalerSomSkalOppdateres, false)
        .then(this._hentArbeidsliste)
        .then(liste => this._onDataMotatt(liste))
    }

    _visOppdatererArbeidsliste(){
        this.setState({
            laster: true,
            lasterSideTekst: 'Oppdaterer arbeidsliste'
        })
    }

    _redigerListe() {
        this.props.history.push('/planlegging/rediger/' + this.state.id)
    }

    render() {
        return (
            <div>
                {this.state.feil ? (
                    <p>
                        {this.state.feil}{' '}
                        <a href="" onClick={e => { e.preventDefault(); window.location.reload() }}>Last på nytt</a>
                    </p>
                ) : this.state.laster ? (
                    <Lodading tekst={this.state.lasterSideTekst} />
                ) : (
                    <Arbeidsliste
                        vannmaalere={this.state.vannmaalere}
                        oppdateArbeidsliste={this._oppdaterArbeidsListe}
                        startdato={this.state.startdato}
                        status={this.state.status}
                        startTidspunkt={this.state.startTidspunkt}
                        sluttTidspunkt={this.state.sluttTidspunkt}
                        tittel={this.state.tittel}
                        beskrivelse={this.state.beskrivelse}
                        vannmaalerIder={this.state.vannmaalerIder}
                        fjernMaalerFraListe={this._fjernMaalerFraListe}
                        oppdaterVannmaalerAvtalt={this._settAvtaltForVannmaaler}
                        sendVarsel={this._sendVarselForArbeidsliste}
                        leggTilInfoFraKunde={this._leggtilInfoFraKunde}
                        sisteAvtaldato={this.state.sisteAvtaltdato}
                        endreAvtaltTidspunt={this._endreAvtaltTidspunt}
                        endreListeIdPaaMaaler={this._endreListeIdPaaMaaler}
                        redigerListe={() => this._redigerListe()}
                        id={this.state.id}
                        lasterSms={this.state.lasterSms}
                    />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/arbeidslisteContainer.jsx